import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './FloatingLanguageSwitcher.css';
import { track } from '@vercel/analytics';

// Import flag images
import usFlag from '../../assets/images/flags/us.jpg';
import saFlag from '../../assets/images/flags/sa.jpg';

const FloatingLanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  // Toggle language with enhanced analytics
  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'ar' : 'en';

    // Track detailed language switch event
    track('language_switcher_click', {
      from: language,
      to: newLanguage,
      component: 'floating_switcher',
      page_location: window.location.pathname,
      user_agent: navigator.userAgent,
      screen_width: window.innerWidth,
      timestamp: new Date().toISOString()
    });

    setLanguage(newLanguage);

    // Save to localStorage
    localStorage.setItem('preferred-language', newLanguage);

    // Update HTML attributes
    document.documentElement.setAttribute('lang', newLanguage);
    document.body.setAttribute('dir', newLanguage === 'ar' ? 'rtl' : 'ltr');
  };

  return (
    <div className="floating-language-switcher">
      <button
        className="language-toggle-btn"
        onClick={toggleLanguage}
        aria-label={language === 'en' ? 'Switch to Arabic' : 'Switch to English'}
      >
        {/* Option 1: Image-based flags */}
        <img
          src={language === 'en' ? saFlag : usFlag}
          alt={language === 'en' ? 'Arabic' : 'English'}
          className="flag-icon"
        />

        {/* Language name */}
        <span className="language-name">
          {language === 'en' ? 'العربية' : 'English'}
        </span>
      </button>
    </div>
  );
};

export default FloatingLanguageSwitcher;